import { render, staticRenderFns } from "./PublicHolidayRegionImport.vue?vue&type=template&id=40a7bc81"
import script from "./PublicHolidayRegionImport.vue?vue&type=script&lang=js"
export * from "./PublicHolidayRegionImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports